import { toast } from "@/hooks/use-toast";
import { exportToWord } from "./wordExport";
import { exportToSheets } from "./sheetsExport";
import { 
  exportFlowchartToPDF, 
  exportFlowchartToJPEG, 
  exportFlowchartToWord,
  exportFlowchartWithErrorHandling 
} from "./flowchartExport";

// Export the public API
export {
  exportToWord,
  exportToSheets,
  exportFlowchartToPDF,
  exportFlowchartToJPEG,
  exportFlowchartToWord,
  exportFlowchartWithErrorHandling
};

// Re-export error handling wrappers to maintain the exact same API
export const exportToWordWithErrorHandling = (nodes: any, edges: any, title: string = "Whiteboard"): void => {
  try {
    // Ensure title is a string
    exportToWord(nodes, edges, String(title));
  } catch (error) {
    console.error("Failed to export to Word:", error);
    toast({
      title: "Export Failed",
      description: "Could not export to Word format. Please try again.",
      variant: "destructive",
    });
  }
};

export const exportToSheetsWithErrorHandling = (nodes: any, edges: any, title: string = "Whiteboard"): void => {
  try {
    // Ensure title is a string
    exportToSheets(nodes, edges, String(title));
  } catch (error) {
    console.error("Failed to export to Sheets:", error);
    toast({
      title: "Export Failed",
      description: "Could not export to Sheets format. Please try again.",
      variant: "destructive",
    });
  }
};
